import ReactDOM from "react-dom/client";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {PublicClientApplication} from "@azure/msal-browser";
import {MsalProvider} from "@azure/msal-react";
import {msalConfig} from "./config/authConfig";
import {PostFormProvider} from "./context/PostFormContext";
import {ModalProvider} from "./context/ModalContext";
import {CommentLikeModalProvider} from "./context/CommentLikeModalContext";
import {ImagePostModalProvider} from "./context/ImagePostModalContext";
import {CommentModalProvider} from "./context/CommentDeleteModalContext";
import App from "./App";
import "./index.css";

const msalInstance = new PublicClientApplication(msalConfig);
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <MsalProvider instance={msalInstance}>
    <QueryClientProvider client={queryClient}>
      <PostFormProvider>
        <ModalProvider>
          <CommentLikeModalProvider>
            <ImagePostModalProvider>
              <CommentModalProvider>
                <App />
              </CommentModalProvider>
            </ImagePostModalProvider>
          </CommentLikeModalProvider>
        </ModalProvider>
      </PostFormProvider>
    </QueryClientProvider>
  </MsalProvider>
);
